import { useTranslation } from 'react-i18next';
import { Table, Header, Row } from '../styles';
import { TableProps } from '../table-props';

const StructureSelectDisclaimerTable = ({ structureName }: TableProps) => {
  const { t } = useTranslation();
  return (
    <Table>
      <thead>
        <Row>
          <Header align={'left'} className="bold-text-cell">
            {t('concrete.structuralElements.disclaimer.fireResistance.label')}
          </Header>
          {t('concrete.structuralElements.disclaimer.fireResistance.list')
            .split(';')
            .map((value, index) => (
              <Header key={`${index}. ${value} minutes`}>{`${value} ${t(
                'concrete.structuralElements.disclaimer.fireResistance.minutes'
              )}`}</Header>
            ))}
        </Row>
      </thead>
      <tbody>
        <Row>
          <td className="bold-text-cell">{`${t(
            `concrete.structuralElements.disclaimer.${structureName.split('.')[0]}.minLabel`
          )}`}</td>
          {t(
            `concrete.structuralElements.disclaimer.${structureName}.minValues`
          )
            .split(';')
            .map((value, index) => (
              <td align={'center'} key={`${index}. ${value} min`}>
                {value}
              </td>
            ))}
        </Row>
        <Row>
          <td className="bold-text-cell">{`${t(
            'concrete.structuralElements.disclaimer.requiredAxisDistance'
          )} ${t('concrete.structuralElements.disclaimer.mm')}`}</td>
          {t(
            `concrete.structuralElements.disclaimer.${structureName}.requiredAxisDistanceValues`
          )
            .split(';')
            .map((value, index) => (
              <td align={'center'} key={`${index}. ${value} requiredAxis`}>
                {value}
              </td>
            ))}
        </Row>
      </tbody>
    </Table>
  );
};

export default StructureSelectDisclaimerTable;
